module.exports = __webpack_public_path__ + "img/info.f65afb02.svg";